<nz-space nzDirection="vertical" style="width: 100%">
  <nz-space-item style="text-align: right;">
    <nz-space>
      <nz-space-item>
        <nz-switch [(ngModel)]="displayMode" [nzCheckedChildren]="'Compact' | locale"
          [nzUnCheckedChildren]="'Detailed' | locale" (ngModelChange)="displayModeChange();"></nz-switch>
      </nz-space-item>
      <!-- <nz-space-item>
        <nz-switch [(ngModel)]="scanMode" [nzCheckedChildren]="'Scan' | locale"
          [nzUnCheckedChildren]="'Manual' | locale" (ngModelChange)="scanModeChange();"></nz-switch>
      </nz-space-item> -->
      <nz-space-item>
        <nz-radio-group [(ngModel)]="dataDisplayMode" (ngModelChange)="dataDisplayModeChange();">
          <label nz-radio-button nzValue="T">
            <i nz-icon nzType="table" nzTheme="outline"></i>
          </label>
          <label nz-radio-button nzValue="C">
            <i nz-icon nzType="appstore" nzTheme="outline"></i>
          </label>
        </nz-radio-group>
      </nz-space-item>
      <!-- <nz-space-item *ngIf="!scanMode">
        <button nz-button nzType="primary" (click)="addNewSerial();">
          <i nz-icon nzType="plus"></i>
        </button>
      </nz-space-item> -->
    </nz-space>
  </nz-space-item>
  <!-- <nz-space-item *ngIf="scanMode"> -->
    <nz-space-item>
    <nz-space nzDirection="vertical" style="width: 100%">
      <nz-space-item *ngIf="binActivated">
        <nz-select [(ngModel)]="selectedBinLocation" (ngModelChange)="selectedBinChanged();" style="width: 100%;" [nzPlaceHolder]="'Bin Location' | locale">
          <nz-option *ngFor="let binLocation of binLocations" [nzValue]="binLocation.AbsEntry"
            [nzLabel]="binLocation.BinCode">
          </nz-option>
        </nz-select>
        <ng-template #ssccIcon>
          <i nz-icon nzType="border" nzTheme="outline"></i>
        </ng-template>
      </nz-space-item>
      <nz-space-item *ngIf="ssccHidden == false">
        <nz-input-group [nzPrefix]="ssccIcon" nzSize="large">
          <input nz-input style="width: 100%;" [(ngModel)]="selectedSSCC"
            (change)="selectedSSCCChange.emit(selectedSSCC); scannedBatchEle.focus();"
            [placeholder]="'Supplier SSCC Number' | locale" />
        </nz-input-group>
        <ng-template #ssccIcon>
          <i nz-icon nzType="border" nzTheme="outline"></i>
        </ng-template>
      </nz-space-item>
      <nz-space-item>
        <nz-input-group [nzPrefix]="scanIcon" nzSize="large">
          <input nz-input #scannedBatchEle style="width: 100%;" [(ngModel)]="scannedSerial" (change)="serialScanned();"
            [placeholder]="'Scan/write serial no.' | locale" />
        </nz-input-group>
        <ng-template #scanIcon>
          <i nz-icon nzType="barcode" nzTheme="outline"></i>
        </ng-template>
      </nz-space-item>
    </nz-space>
  </nz-space-item>
  <nz-space-item *ngIf="dataDisplayMode === 'C'">
    <div nz-row [nzGutter]="[8, 8]">
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="8" *ngFor="let serialNumber of serialNumbers">
        <nz-card [nzTitle]="cardTitle" [nzActions]="[cardDeleteAction]">
          <nz-form-item *ngIf="displayMode === false">
            <nz-form-label [nzSpan]="6">{{'SSCC' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <input nz-input [(ngModel)]="serialNumber.U_ITM_WMS_SSCC" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="8">{{'Man. SN' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <input nz-input [(ngModel)]="serialNumber.ManufacturerSerialNumber" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="8">{{'Serial No' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <input nz-input [(ngModel)]="serialNumber.InternalSerialNumber" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF'">
            <nz-form-control>
              <nz-switch [(ngModel)]="serialNumber.Damaged" [nzCheckedChildren]="'Damaged' | locale"
                [nzUnCheckedChildren]="'Fine' | locale" (ngModelChange)="updateSerialDamaged(serialNumber);"></nz-switch>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="binActivated">
            <nz-form-label [nzSpan]="8">{{'Bin Location' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <nz-select [(ngModel)]="serialNumber.BinLocation">
                <nz-option *ngFor="let binLocation of binLocations" [nzValue]="binLocation.AbsEntry"
                  [nzLabel]="binLocation.BinCode">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-card>
        <ng-template #cardDeleteAction>
          <a nz-popconfirm [nzPopconfirmTitle]="'Are you sure you want to delete?' | locale"
            (nzOnConfirm)="deleteSerial(serialNumber);" style="font-size: 19px;">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </a>
        </ng-template>
        <ng-template #cardTitle>
          {{'Serial' | locale}} #{{serialNumber.InternalSerialNumber}}
        </ng-template>
      </div>
    </div>
  </nz-space-item>
  <nz-space-item *ngIf="dataDisplayMode === 'T'">
    <nz-table #snTable [nzData]="serialNumbers">
      <thead>
        <tr>
          <th></th>
          <th>
            {{'Mfr Serial No.' | locale}}
          </th>
          <th>
            {{'Serial Number' | locale}}
          </th>
          <th *ngIf="binActivated">
            {{'Bin Location' | locale}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let serialNumber of snTable.data">
          <td>
            <a nz-popconfirm [nzPopconfirmTitle]="'Are you sure you want to delete?' | locale"
              (nzOnConfirm)="deleteSerial(serialNumber);" style="font-size: 19px;">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </a>
          </td>
          <td>
            <input nz-input [(ngModel)]="serialNumber.ManufacturerSerialNumber" />
          </td>
          <td>
            <input nz-input [(ngModel)]="serialNumber.InternalSerialNumber" />
          </td>
          <td *ngIf="binActivated">
            <nz-select style="width: 100%" [(ngModel)]="serialNumber.BinLocation">
              <nz-option *ngFor="let binLocation of binLocations" [nzValue]="binLocation.AbsEntry"
                [nzLabel]="binLocation.BinCode">
              </nz-option>
            </nz-select>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-space-item>
</nz-space>
